import Certificate from './Certificate';
import CompanyLocation from './CompanyLocation';
import Country from './Country';
import User from './User';

export type State = 'prospect' | 'customer' | 'audit' | 'audit_accepted' | 'want_cancel_audit' | 'certified' | 'inactive' | 'expired' | 'corrective_actions_management' | 'audit_completed';

interface Company {
    id: number;
    name: string;
    website: string | null;
    vatCode: string | null;
    address: string;
    city: string;
    phoneOffice: string;
    phoneMobile: string | null;
    email: string;
    note: string | null;
    companyReferent: boolean;
    co2Saved?: number | null;
    enableCo2: boolean;
    state: State;
    countryId: number;
    country: Country;
    locations: CompanyLocation[];
    users: User[];
    auditors: User[];
    certifiers: User[];
    certificates: Certificate[];
    co2SavedLastMonths?: any;
    chartData: any;
    enabled: boolean;
    certifiedCo2Saved?: null | number;
    certifiedPlasticReduced?: null | number;
    hasActiveAssessment: boolean;
    canDelete?: boolean;
    lastUpdateDate: string | null;
}

const EmptyCompany: Company = {
    id: 0,
    name: '',
    website: '',
    vatCode: '',
    address: '',
    city: '',
    phoneOffice: '',
    phoneMobile: '',
    email: '',
    note: '',
    companyReferent: false,
    state: 'prospect',
    co2Saved: null,
    enableCo2: false,
    countryId: 0,
    country: {
        id: 0,
        name: ''
    },
    locations: [],
    users: [],
    auditors: [],
    certifiers: [],
    certificates: [],
    co2SavedLastMonths: {},
    chartData: {},
    enabled: true,
    certifiedCo2Saved: null,
    certifiedPlasticReduced: null,
    hasActiveAssessment: false,
    lastUpdateDate: null,
};

export { EmptyCompany };

export default Company;
